/* ==========================================================================
   SearcherBusHotel > Client > Button
   ========================================================================== */

/* Modules */
const ButtonClient = require('@bluekiri/alexandria-contrib-components/components/button/client/js');
const validations = require('../../../../helpers/validations');

/* Init */
function initButton(selector, instance, configuration) {
    document.querySelector(selector).addEventListener('click', () => {
        const destination = instance.location[1].value ? instance.location[1].value.toString().split(',') : false;

        const hotelCodeValue = instance.element.dataset.hotelcode ? instance.element.dataset.hotelcode : '';
        const destinationTypeValue = instance.element.dataset.destinationtype
            ? instance.element.dataset.destinationtype
            : 'CIU';

        const params = {
            productType: 'BusHotel',
            hotelCode: hotelCodeValue,
            originAirportCode: instance.location[0].value,
            hashRooms: getHashRooms(instance.passenger.panelAccommodation.accommodation.roomStore),
            destinationType: destinationTypeValue,
            destinationCode: destination[0],
            destinationAirportCode: destination[1],
            departureDateStr: dateFormat(instance.calendar.fp.selectedDates[0]),
            returnDateStr: dateFormat(instance.calendar.fp.selectedDates[1]),
            FamilyDiscount: 0,
            LineOfBusiness: 'Packages'
        };

        const hotelChainData = instance.element.getAttribute('data-hotel-chain') || '';
        if (hotelChainData) params.hotelChain = hotelChainData;

        const urlParams = paramsDictToUrl(params);

        const validationResult = validations.validateFields(instance);

        if (validationResult.success) {
            if (configuration.target !== undefined) {
                window.open(`${configuration.url}?${urlParams}`, configuration.target);
            } else {
                window.location.assign(`${configuration.url}?${urlParams}`);
                // Modal Loading
                instance.loading.setContentTemplate(instance);
                instance.loading.modal.start();
            }
        } else {
            validationResult.fieldsError.forEach(field => field.setError());
        }
    });

    return ButtonClient(selector, configuration);
}

// TODO: Move to helper
function paramsDictToUrl(params) {
    const arrParams = [];

    Object.keys(params).forEach(key => {
        arrParams.push(`${key}=${params[key]}`);
    });

    return arrParams.join('&');
}

function dateFormat(date) {
    const month = formatDateDigits(date.getMonth() + 1);
    const day = formatDateDigits(date.getDate());
    return `${date.getFullYear()}-${month}-${day}`;
}

function formatDateDigits(number) {
    let fNumber = `${number}`;
    if (fNumber.length === 1) {
        fNumber = `0${fNumber}`;
    }
    return fNumber;
}

function getHashRooms(roomStore) {
    const hashRoomsArr = [];
    Object.keys(roomStore).forEach(key => {
        hashRoomsArr.push(`${roomStore[key].codeHash.adults}${roomStore[key].codeHash.children}`);
    });
    return hashRoomsArr.join('%2C');
}

module.exports = {
    initButton
};
